export const expenseAccrualsPtBr = {
  title: 'Provisões de despesa',
  subtitle: 'Propostas mensais de competência por entidade.',
  reviewTitle: 'Revisão de provisões',
  reviewSubtitle: 'Confirme ou dispense as propostas do mês de competência.',
  suggestionsTitle: 'Sugestões de baixa',
  suggestionsSubtitle: 'Contas aprovadas que podem baixar uma provisão manual.',
  tabs: {
    review: 'Propostas',
    suggestions: 'Sugestões',
    all: 'Todas',
  },
  newManual: 'Nova provisão',
  proposeSync: {
    action: 'Gerar propostas',
    running: 'Gerando propostas…',
    confirmTitle: 'Gerar propostas de provisão?',
    confirmDescription:
      'Cria propostas de provisão para a competência {{month}}, uma por modelo recorrente ativo sem conta a pagar no mês. Modelos já cobertos ou provisionados são ignorados.',
    confirmStaleMonth:
      'Atenção: {{month}} não é a competência atual nem a anterior. Os valores propostos usam a média das contas mais recentes, que pode não refletir os valores daquela época.',
    confirm: 'Gerar propostas',
    cancel: 'Cancelar',
    success_one: '{{count}} nova proposta para {{month}}.',
    success_other: '{{count}} novas propostas para {{month}}.',
    none: 'Nenhuma proposta nova para {{month}}. Os modelos já estão cobertos ou provisionados.',
  },
  confirmLeave: {
    title: 'Descartar alterações?',
    description: 'Há alterações não salvas. Se sair agora, elas serão perdidas.',
    confirm: 'Sair sem salvar',
    stay: 'Continuar editando',
  },
  filters: {
    entity: 'Entidade',
    month: 'Competência',
    status: 'Status',
    origin: 'Origem',
    applied: 'Filtros aplicados',
    clearAll: 'Limpar filtros',
    filterEntity: 'Filtrar por entidade',
    filterVendor: 'Filtrar por fornecedor',
    vendorPlaceholder: 'Buscar fornecedor',
    vendorSearchHint: 'Digite para buscar um fornecedor.',
    clearVendor: 'Limpar fornecedor',
    filterTemplate: 'Filtrar por modelo',
    filterRecurrence: 'Filtrar por recorrência',
    filterMonth: 'Filtrar por competência',
    filterStatus: 'Filtrar por status',
    filterOrigin: 'Filtrar por origem',
    filterAmount: 'Filtrar por valor',
    amountMinimum: 'Valor mínimo',
    amountMaximum: 'Valor máximo',
    minimum: 'Mínimo',
    maximum: 'Máximo',
    allStatuses: 'Todos',
    allOrigins: 'Todas',
    allEntities: 'Todas as entidades',
    monthPlaceholder: 'AAAA-MM',
    monthInvalid: 'Use o formato AAAA-MM (ex.: 2026-08).',
    templatePlaceholder: 'Buscar modelo recorrente',
    recurrencePlaceholder: 'Buscar recorrência',
  },
  sort: {
    tooltip: 'Clique para ordenar por esta coluna',
    sortBy: 'Ordenar por {{column}}{{direction}}',
    asc: 'crescente',
    desc: 'decrescente',
  },
  columns: {
    entity: 'Entidade',
    vendor: 'Fornecedor',
    template: 'Modelo',
    recurrence: 'Recorrência',
    origin: 'Origem',
    month: 'Competência',
    amount: 'Valor',
    status: 'Status',
    select: 'Selecionar',
    memo: 'Histórico',
    actions: 'Ações',
  },
  glPosting: {
    openAria: 'Ver lançamentos contábeis de {{name}}',
    subtitle: '{{vendor}} • {{month}}',
  },
  recurrence: {
    loading: 'Carregando contas da recorrência.',
    openAria: 'Abrir recorrência {{name}}',
    expandAria: 'Expandir contas da recorrência {{name}}',
    collapseAria: 'Recolher contas da recorrência {{name}}',
    loadError: 'Não foi possível carregar a recorrência e suas contas.',
    empty: 'Nenhuma conta vinculada encontrada para esta recorrência.',
    openBill: 'Abrir conta',
    columns: {
      competency: 'Competência',
      dueDate: 'Vencimento',
      status: 'Status',
      netAmount: 'Valor líquido',
      totalAmount: 'Valor total',
      bill: 'Conta',
    },
  },
  origin: {
    TEMPLATE: 'Recorrência',
    MANUAL: 'Manual',
    FIXED: 'Fixo',
    VARIABLE: 'Variável',
  },
  status: {
    PROPOSED: 'Proposta',
    POSTED: 'Lançada',
    DISMISSED: 'Dispensada',
    SETTLED: 'Baixada',
  },
  loading: 'Carregando provisões',
  empty: 'Nenhuma provisão encontrada.',
  emptyFiltered: 'Nenhuma provisão corresponde aos filtros.',
  emptyFilteredDescription: 'Limpe os filtros para ver todas as provisões.',
  emptySuggestions: 'Nenhuma sugestão de baixa pendente.',
  loadError: 'Não foi possível carregar as provisões.',
  pagination: {
    page: 'Página {{page}} de {{totalPages}}',
    summary_one: 'Página {{page}} de {{totalPages}} • {{count}} resultado',
    summary_other: 'Página {{page}} de {{totalPages}} • {{count}} resultados',
  },
  selection: {
    selected: '{{count}} selecionada(s)',
    selectAll: 'Selecionar visíveis',
    clear: 'Limpar seleção',
    total: 'Total selecionado',
    totalMixedCurrency: 'Seleção com moedas diferentes.',
    empty: 'Selecione ao menos uma provisão.',
  },
  actions: {
    confirmSelected: 'Confirmar selecionadas',
    dismissSelected: 'Dispensar selecionadas',
    confirm: 'Confirmar',
    dismiss: 'Dispensar',
    keep: 'Manter',
    reverse: 'Reverter',
    ignore: 'Ignorar',
    drain: 'Estornar agora',
    retry: 'Tentar novamente',
    cancel: 'Cancelar',
  },
  errors: {
    validationFallback:
      'Não foi possível validar a provisão. Verifique os campos e tente novamente.',
  },
  confirmConfirm: {
    title: 'Confirmar provisões',
    description:
      'Provisões serão lançadas no razão. Esta ação não pode ser desfeita sem um estorno.',
    confirm: 'Confirmar e lançar',
    configureAccount: 'Configurar conta de provisões',
  },
  confirmDismiss: {
    title: 'Dispensar provisões',
    description: '{{count}} provisão(ões) serão dispensadas sem lançamento contábil.',
    confirm: 'Dispensar',
  },
  confirmSuggestion: {
    title: 'Confirmar baixa da provisão',
    description:
      'A provisão será estornada no razão para liquidar a conta. Esta ação não pode ser desfeita.',
    confirm: 'Confirmar baixa',
  },
  confirmIgnore: {
    title: 'Ignorar sugestão',
    description: 'A sugestão será ignorada. A provisão permanecerá em aberto.',
    confirm: 'Ignorar',
  },
  confirmKeep: {
    title: 'Manter provisão no fechamento',
    description: 'A provisão permanecerá em aberto após o fechamento do período.',
    descriptionReopened:
      'A decisão anterior perdeu a validade porque a estimativa mudou. Confirme a nova decisão de manter a provisão em aberto.',
    reasonLabel: 'Motivo (opcional)',
    reasonPlaceholder: 'Por que esta estimativa continua em aberto?',
    confirm: 'Manter',
  },
  confirmReverse: {
    title: 'Reverter provisão no fechamento',
    description: 'A provisão será estornada na data de fechamento do período.',
    confirm: 'Reverter',
  },
  confirmDrain: {
    title: 'Lançar estorno pendente',
    description:
      'O estorno automático de {{entryNumber}} será lançado na data prometida ({{targetDate}}).',
    descriptionShifted:
      'O período da data prometida ({{targetDate}}) está fechado. O estorno automático de ' +
      '{{entryNumber}} será lançado em {{effectiveDate}}, no primeiro período aberto seguinte.',
    confirm: 'Estornar agora',
  },
  confirmDiscardDraft: {
    title: 'Descartar rascunho do lançamento',
    description:
      'Você tem um rascunho de lançamento manual não salvo. Trocar o tipo de lançamento descarta o rascunho.',
    confirm: 'Descartar e trocar',
  },
  confirmDiscardAccrual: {
    title: 'Descartar dados da provisão',
    description:
      'Você tem dados de provisão não salvos. Trocar o tipo de lançamento descarta o que foi preenchido.',
    confirm: 'Descartar e trocar',
  },
  toast: {
    confirmed: 'Provisões confirmadas.',
    dismissed: 'Provisões dispensadas.',
    suggestionConfirmed: 'Baixa confirmada.',
    suggestionIgnored: 'Sugestão ignorada.',
    kept: 'Provisão mantida no fechamento.',
    keptNotRecorded: {
      NO_CURRENT_ASSESSMENT:
        'A decisão não entrou no histórico do controle de estimativas: ainda não há avaliação salva para este período. Salve a avaliação antes de Manter para registrar a decisão.',
      NOT_IN_CURRENT_ASSESSMENT:
        'A decisão não entrou no histórico do controle de estimativas: a avaliação salva é anterior a esta estimativa. Salve a avaliação antes de Manter para registrar a decisão.',
      ASSESSMENT_OUTDATED:
        'A decisão não entrou no histórico do controle de estimativas: a estimativa mudou depois da avaliação salva. Salve a avaliação antes de Manter para registrar a decisão.',
      RESTRICTED_VIEWER:
        'A decisão não entrou no histórico do controle de estimativas: seu acesso não inclui registros de folha confidenciais.',
    },
    reversed: 'Provisão revertida.',
    created: 'Provisão manual criada.',
    configSaved: 'Conta de provisão salva.',
    drained: 'Estorno pendente lançado.',
    partialFailure: 'Algumas provisões não puderam ser processadas.',
  },
  amountInvalid: 'Informe um valor válido com centavos.',
  workbench: {
    kindLabel: 'Tipo de lançamento',
    journal: 'Lançamento manual',
    expenseAccrual: 'Provisão de despesa',
    editorTitle: 'Nova provisão de despesa',
    editorSubtitle: 'Registre a despesa na competência correta antes da chegada da conta.',
    detailsTitle: 'Dados da provisão',
    detailsSubtitle: 'Informe a origem, a competência e a classificação da despesa.',
    vendor: 'Fornecedor',
    competency: 'Competência',
    competencyPlaceholder: 'Mês / Ano',
    amount: 'Valor',
    expenseAccount: 'Conta de despesa',
    liabilityHint:
      'A conta de "Provisões de despesas a pagar" da entidade será usada automaticamente na confirmação.',
    validationTitle: 'Validações',
    postingTitle: 'Na contabilização',
    validation: {
      entity: 'Entidade selecionada',
      vendor: 'Fornecedor selecionado',
      competency: 'Competência informada',
      amount: 'Valor informado',
      expenseAccount: 'Conta de despesa selecionada',
    },
    save: 'Criar provisão',
    saving: 'Criando…',
    cancel: 'Cancelar',
    missingPropose: 'Você não tem permissão para propor provisões de despesa.',
  },
  settings: {
    title: 'Provisões de despesas a pagar',
    subtitle: 'Conta de passivo usada para confirmar provisões de competência da entidade.',
    account: 'Conta de provisão',
    save: 'Salvar',
    saving: 'Salvando…',
    emptyEntities: 'Nenhuma entidade ativa encontrada.',
    confirmDiscardDraft: {
      title: 'Descartar alteração não salva',
      description:
        'A conta de provisão selecionada para esta entidade ainda não foi salva. Trocar de entidade descarta a alteração.',
      confirm: 'Descartar e trocar',
    },
    noPermission: 'Você não tem permissão para alterar a conta de provisão.',
    missingVersion: 'Não foi possível resolver o plano de contas ativo desta entidade.',
  },
  suggestions: {
    bill: 'Conta',
    accrual: 'Provisão',
    billAmount: 'Valor da conta',
    accrualAmount: 'Valor da provisão',
    billDate: 'Competência da conta',
    accrualMonth: 'Competência da provisão',
    createdAt: 'Sugerida em',
    detailError: 'Não foi possível carregar os detalhes desta sugestão.',
    loadError: 'Não foi possível carregar as sugestões de baixa.',
  },
  checklist: {
    title: 'Provisões em aberto',
    subtitle: 'Mantenha ou reverta cada provisão lançada antes de fechar o período.',
    empty: 'Nenhuma provisão em aberto neste período.',
    loadError: 'Não foi possível carregar as provisões em aberto.',
    drainTitle: 'Estornos automáticos pendentes',
    drainSubtitle:
      'Lançamentos manuais com estorno automático aguardando o período de destino aberto.',
    drainEmpty: 'Nenhum estorno automático pendente neste período.',
    drainLoadError: 'Não foi possível carregar os estornos automáticos pendentes.',
    targetDate: 'Data do estorno',
    entryNumber: 'Lançamento',
    memo: 'Histórico',
    amount: 'Valor',
    vendor: 'Fornecedor',
    selectEntity: 'Selecione uma entidade para ver os estornos automáticos pendentes.',
    targetPeriodClosed: 'Sem período aberto',
    targetPeriodClosedHint:
      'Não há período aberto na data prometida nem depois dela. Abra um período para lançar este estorno.',
    targetPeriodShifted: 'Data deslocada',
    targetPeriodShiftedHint:
      'O período da data prometida está fechado. O estorno será lançado em {{date}}, no primeiro período aberto seguinte.',
    showingOf: 'Exibindo {{shown}} de {{total}}',
    invalidated: 'Revisão invalidada',
    invalidatedDetail:
      'Mantida em {{date}} por {{name}}. A estimativa mudou depois disso, então a decisão perdeu a validade.',
    awaitingSettlement: 'Nota vinculada aguardando baixa — confirmar no AP06',
  },
};

export const expenseAccrualsEn = {
  title: 'Expense accruals',
  subtitle: 'Monthly competency proposals by entity.',
  reviewTitle: 'Accrual review',
  reviewSubtitle: 'Confirm or dismiss the competency-month proposals.',
  suggestionsTitle: 'Settlement suggestions',
  suggestionsSubtitle: 'Approved bills that may settle a manual accrual.',
  tabs: {
    review: 'Proposals',
    suggestions: 'Suggestions',
    all: 'All',
  },
  newManual: 'New accrual',
  proposeSync: {
    action: 'Generate proposals',
    running: 'Generating proposals…',
    confirmTitle: 'Generate accrual proposals?',
    confirmDescription:
      'Creates accrual proposals for competency {{month}}, one per active recurring template without a bill in the month. Templates already covered or accrued are skipped.',
    confirmStaleMonth:
      'Warning: {{month}} is not the current or previous competency. Proposed amounts use the average of the most recent bills, which may not reflect that period.',
    confirm: 'Generate proposals',
    cancel: 'Cancel',
    success_one: '{{count}} new proposal for {{month}}.',
    success_other: '{{count}} new proposals for {{month}}.',
    none: 'No new proposals for {{month}}. Templates are already covered or accrued.',
  },
  confirmLeave: {
    title: 'Discard changes?',
    description: 'You have unsaved changes. If you leave now, they will be lost.',
    confirm: 'Leave without saving',
    stay: 'Keep editing',
  },
  filters: {
    entity: 'Entity',
    month: 'Competency',
    status: 'Status',
    origin: 'Origin',
    applied: 'Applied filters',
    clearAll: 'Clear filters',
    filterEntity: 'Filter by entity',
    filterVendor: 'Filter by vendor',
    vendorPlaceholder: 'Search vendor',
    vendorSearchHint: 'Type to search for a vendor.',
    clearVendor: 'Clear vendor',
    filterTemplate: 'Filter by template',
    filterRecurrence: 'Filter by recurrence',
    filterMonth: 'Filter by competency',
    filterStatus: 'Filter by status',
    filterOrigin: 'Filter by origin',
    filterAmount: 'Filter by amount',
    amountMinimum: 'Minimum amount',
    amountMaximum: 'Maximum amount',
    minimum: 'Minimum',
    maximum: 'Maximum',
    allStatuses: 'All',
    allOrigins: 'All',
    allEntities: 'All entities',
    monthPlaceholder: 'YYYY-MM',
    monthInvalid: 'Use the YYYY-MM format (e.g. 2026-08).',
    templatePlaceholder: 'Search recurring template',
    recurrencePlaceholder: 'Search recurrence',
  },
  sort: {
    tooltip: 'Click to sort by this column',
    sortBy: 'Sort by {{column}}{{direction}}',
    asc: 'ascending',
    desc: 'descending',
  },
  columns: {
    entity: 'Entity',
    vendor: 'Vendor',
    template: 'Template',
    recurrence: 'Recurrence',
    origin: 'Origin',
    month: 'Competency',
    amount: 'Amount',
    status: 'Status',
    select: 'Select',
    memo: 'Memo',
    actions: 'Actions',
  },
  glPosting: {
    openAria: 'View accounting entries for {{name}}',
    subtitle: '{{vendor}} • {{month}}',
  },
  recurrence: {
    loading: 'Loading recurrence bills.',
    openAria: 'Open recurrence {{name}}',
    expandAria: 'Expand bills for recurrence {{name}}',
    collapseAria: 'Collapse bills for recurrence {{name}}',
    loadError: 'Could not load the recurrence and its bills.',
    empty: 'No linked bills were found for this recurrence.',
    openBill: 'Open bill',
    columns: {
      competency: 'Competency',
      dueDate: 'Due date',
      status: 'Status',
      netAmount: 'Net amount',
      totalAmount: 'Total amount',
      bill: 'Bill',
    },
  },
  origin: {
    TEMPLATE: 'Recurring',
    MANUAL: 'Manual',
    FIXED: 'Fixed',
    VARIABLE: 'Variable',
  },
  status: {
    PROPOSED: 'Proposed',
    POSTED: 'Posted',
    DISMISSED: 'Dismissed',
    SETTLED: 'Settled',
  },
  loading: 'Loading expense accruals',
  empty: 'No expense accruals found.',
  emptyFiltered: 'No accruals match the filters.',
  emptyFilteredDescription: 'Clear the filters to see all accruals.',
  emptySuggestions: 'No pending settlement suggestions.',
  loadError: 'Could not load expense accruals.',
  pagination: {
    page: 'Page {{page}} of {{totalPages}}',
    summary_one: 'Page {{page}} of {{totalPages}} • {{count}} result',
    summary_other: 'Page {{page}} of {{totalPages}} • {{count}} results',
  },
  selection: {
    selected: '{{count}} selected',
    selectAll: 'Select visible',
    clear: 'Clear selection',
    total: 'Selected total',
    totalMixedCurrency: 'Selection spans multiple currencies.',
    empty: 'Select at least one accrual.',
  },
  actions: {
    confirmSelected: 'Confirm selected',
    dismissSelected: 'Dismiss selected',
    confirm: 'Confirm',
    dismiss: 'Dismiss',
    keep: 'Keep',
    reverse: 'Reverse',
    ignore: 'Ignore',
    drain: 'Reverse now',
    retry: 'Try again',
    cancel: 'Cancel',
  },
  errors: {
    validationFallback: 'Could not validate the accrual. Check the fields and try again.',
  },
  confirmConfirm: {
    title: 'Confirm accruals',
    description: 'Accruals will be posted to the ledger. This cannot be undone without a reversal.',
    confirm: 'Confirm and post',
    configureAccount: 'Configure accrual account',
  },
  confirmDismiss: {
    title: 'Dismiss accruals',
    description: '{{count}} accrual(s) will be dismissed without posting.',
    confirm: 'Dismiss',
  },
  confirmSuggestion: {
    title: 'Confirm accrual settlement',
    description:
      'The accrual will be reversed in the ledger to settle the bill. This cannot be undone.',
    confirm: 'Confirm settlement',
  },
  confirmIgnore: {
    title: 'Ignore suggestion',
    description: 'The suggestion will be ignored. The accrual remains open.',
    confirm: 'Ignore',
  },
  confirmKeep: {
    title: 'Keep accrual at close',
    description: 'The accrual will remain open after period close.',
    descriptionReopened:
      'The earlier decision no longer holds because the estimate changed. Confirm the new decision to keep the accrual open.',
    reasonLabel: 'Reason (optional)',
    reasonPlaceholder: 'Why does this estimate stay open?',
    confirm: 'Keep',
  },
  confirmReverse: {
    title: 'Reverse accrual at close',
    description: 'The accrual will be reversed on the period close date.',
    confirm: 'Reverse',
  },
  confirmDrain: {
    title: 'Post pending reversal',
    description:
      'The automatic reversal of {{entryNumber}} will post on its promised date ({{targetDate}}).',
    descriptionShifted:
      'The period for the promised date ({{targetDate}}) is closed. The automatic reversal of ' +
      '{{entryNumber}} will post on {{effectiveDate}}, in the first open period after it.',
    confirm: 'Reverse now',
  },
  confirmDiscardDraft: {
    title: 'Discard journal draft',
    description: 'You have an unsaved manual journal draft. Switching the entry type discards it.',
    confirm: 'Discard and switch',
  },
  confirmDiscardAccrual: {
    title: 'Discard accrual data',
    description: 'You have unsaved accrual data. Switching the entry type discards what you typed.',
    confirm: 'Discard and switch',
  },
  toast: {
    confirmed: 'Accruals confirmed.',
    dismissed: 'Accruals dismissed.',
    suggestionConfirmed: 'Settlement confirmed.',
    suggestionIgnored: 'Suggestion ignored.',
    kept: 'Accrual kept at close.',
    keptNotRecorded: {
      NO_CURRENT_ASSESSMENT:
        'The decision was not added to the estimates control history: no assessment is saved for this period yet. Save the assessment before Keeping to record the decision.',
      NOT_IN_CURRENT_ASSESSMENT:
        'The decision was not added to the estimates control history: the saved assessment predates this estimate. Save the assessment before Keeping to record the decision.',
      ASSESSMENT_OUTDATED:
        'The decision was not added to the estimates control history: the estimate changed after the saved assessment. Save the assessment before Keeping to record the decision.',
      RESTRICTED_VIEWER:
        'The decision was not added to the estimates control history: your access does not include confidential payroll records.',
    },
    reversed: 'Accrual reversed.',
    created: 'Manual accrual created.',
    configSaved: 'Accrual account saved.',
    drained: 'Pending reversal posted.',
    partialFailure: 'Some accruals could not be processed.',
  },
  amountInvalid: 'Enter a valid amount with cent precision.',
  workbench: {
    kindLabel: 'Entry type',
    journal: 'Manual journal',
    expenseAccrual: 'Expense accrual',
    editorTitle: 'New expense accrual',
    editorSubtitle: 'Record the expense in the correct competency before the bill arrives.',
    detailsTitle: 'Accrual details',
    detailsSubtitle: 'Enter the source, competency, and expense classification.',
    vendor: 'Vendor',
    competency: 'Competency',
    competencyPlaceholder: 'Month / Year',
    amount: 'Amount',
    expenseAccount: 'Expense account',
    liabilityHint:
      'The entity “Accrued expenses payable” account is applied automatically on confirm.',
    validationTitle: 'Validations',
    postingTitle: 'When posted',
    validation: {
      entity: 'Entity selected',
      vendor: 'Vendor selected',
      competency: 'Competency entered',
      amount: 'Amount entered',
      expenseAccount: 'Expense account selected',
    },
    save: 'Create accrual',
    saving: 'Creating…',
    cancel: 'Cancel',
    missingPropose: 'You do not have permission to propose expense accruals.',
  },
  settings: {
    title: 'Accrued expenses payable',
    subtitle: 'Liability account used when confirming competency accruals for the entity.',
    account: 'Accrual account',
    save: 'Save',
    saving: 'Saving…',
    emptyEntities: 'No active entities found.',
    confirmDiscardDraft: {
      title: 'Discard unsaved change',
      description:
        'The accrual account picked for this entity has not been saved. Switching entities discards it.',
      confirm: 'Discard and switch',
    },
    noPermission: 'You do not have permission to change the accrual account.',
    missingVersion: 'Could not resolve the active chart of accounts for this entity.',
  },
  suggestions: {
    bill: 'Bill',
    accrual: 'Accrual',
    billAmount: 'Bill amount',
    accrualAmount: 'Accrual amount',
    billDate: 'Bill competency',
    accrualMonth: 'Accrual competency',
    createdAt: 'Suggested at',
    detailError: 'Could not load the details for this suggestion.',
    loadError: 'Could not load settlement suggestions.',
  },
  checklist: {
    title: 'Open accruals',
    subtitle: 'Keep or reverse each posted accrual before closing the period.',
    empty: 'No open accruals in this period.',
    loadError: 'Could not load open accruals.',
    drainTitle: 'Pending automatic reversals',
    drainSubtitle: 'Manual entries waiting for the target period to open.',
    drainEmpty: 'No pending automatic reversals for this period.',
    drainLoadError: 'Could not load pending automatic reversals.',
    targetDate: 'Reversal date',
    entryNumber: 'Entry',
    memo: 'Memo',
    amount: 'Amount',
    vendor: 'Vendor',
    selectEntity: 'Select an entity to see pending automatic reversals.',
    targetPeriodClosed: 'No open period',
    targetPeriodClosedHint:
      'No period is open on the promised date or after it. Open one to post this reversal.',
    targetPeriodShifted: 'Date shifted',
    targetPeriodShiftedHint:
      'The promised date period is closed. The reversal will post on {{date}}, in the first open period after it.',
    showingOf: 'Showing {{shown}} of {{total}}',
    invalidated: 'Review invalidated',
    invalidatedDetail:
      'Kept on {{date}} by {{name}}. The estimate changed after that, so the decision no longer holds.',
    awaitingSettlement: 'Linked bill awaiting settlement — confirm in AP06',
  },
};
